export default __webpack_public_path__ + "static/Survicate-e4e4cd82fa94f4aefdfe7f096a9aeea5.png";